import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { IAcessorio } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ListaPaginada } from 'src/app/models';
import { AuthenticationService } from 'src/app/services';
import { SuprimentosService } from 'src/app/services/suprimentos/suprimentos.service';
import { ModalGeneralComponent } from '../modal-general/modal-general.component';

@Component({
  selector: 'app-listagem-acessorios',
  templateUrl: './listagem-acessorios.component.html',
  styleUrls: ['./listagem-acessorios.component.scss']
})
export class ListagemAcessoriosComponent implements OnInit, OnDestroy {
  @ViewChild(ModalGeneralComponent) modal: ModalGeneralComponent;
  subscriptions$ = new Subscription();
  @Input()
  codContrato = '';
  @Input()
  numSerie = '';
  acessorios = new ListaPaginada<IAcessorio>();
  public get nomesAcessorios(): string {
    return this.acessorios.registros.reduce(
      (prev, el) => `${prev && prev + ', '}${el.nomeProdutoSuprimento}`,
      ''
    );
  }
  colunasVisiveis: string[] = [
    'nomeMarcaProdutoSuprimento',
    'nomeProdutoSuprimento'
  ];
  token: IToken;
  constructor(
    private suprimentosService: SuprimentosService,
    private authenticationService: AuthenticationService
  ) {}

  getAcessorios() {
    this.subscriptions$.add(
      this.suprimentosService
        .getAcessorios({
          idUsuario: this.token?.id,
          codContrato: this.codContrato,
          numSerie: this.numSerie,
          paginar: false
        })
        .subscribe({
          next: ({ data }) => {
            this.acessorios = data;
          }
        })
    );
  }
  abrirModal() {
    this.modal.openModal();
  }
  fecharModal() {
    this.modal.closeModalWithoutReload();
  }
  ngOnInit(): void {
    this.token = this.authenticationService.obterToken();
    this.getAcessorios();
  }
  ngOnDestroy(): void {
    this.fecharModal();
    this.subscriptions$.unsubscribe();
  }
}
